// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2JEos","name":"ConsentHeader_name__SqSkg","birthday":"ConsentHeader_birthday__1xKLk","skeleton":"ConsentHeader_skeleton__3QPpu"};